import { BaseReducer } from '@hobs/utils/baseReducer';
import {
  exerciseStaticData,
  exerciseGet,
  exercisePost,
  exercisePut,
  CURRENT
} from '@hobs/constants/exercises';

class Exercise extends BaseReducer {
  static defaultState = {
    parties: [],
    exercise: null,
    current: {}
  };

  constructor() {
    super(Exercise.defaultState);
    this.actionMap = {
      [exerciseStaticData.SUCCESS]: this.loadStaticData,
      [exercisePost.SUCCESS]: this.loadExercise,
      [exercisePut.SUCCESS]: this.loadExercise,
      [exerciseGet.RESET]: this.resetData,
      [exerciseGet.SUCCESS]: this.loadExercise,
      [CURRENT.SUCCESS]: this.loadCurrentExercise
    };
  }

  loadExercise = (state, action) => {
    return Object.assign({}, state, {
      exercise: action.payload
    });
  };

  loadStaticData = (state, action) => {
    return Object.assign({}, state, {
      parties: action.payload.parties
    });
  };

  loadCurrentExercise = (state, action) => {
    return Object.assign({}, state, {
      current: action.payload
    });
  };

  resetData = state => {
    return Object.assign({}, state, {
      parties: [],
      exercise: null
    });
  };
}
export default new Exercise().reducer;
